import React from 'react';
import classNames from 'classnames';
import path from 'path';
import { PMS_URL } from '../../config';
import { AppLink } from '../modules/routing/containers';

class InventoryMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.isDropdownOpen = this.isDropdownOpen.bind(this);
    this.handleClickDropdown = this.handleClickDropdown.bind(this);
    this.state = {
      dropdowns: {
        dataExchange: false,
        dailyRental: false,
      }
    };
  }
  componentDidMount() {
    this.openDropdownFor(this.props.location.pathname);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.openDropdownFor(nextProps.location.pathname);
    }
  }
  render() {
    const root = '/inventory';
    return (
      <ul className="sidebar-menu">

        <li className={ classNames({ active: this.isActive('/properties') }) }>
          <AppLink to="/properties" customRoot={ root }><i className="fas fa-home fa-fw"></i> <span>Properties</span></AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/propertyGroups') }) }>
          <AppLink to="/propertyGroups" customRoot={ root }><i className="fas fa-th fa-fw"></i> <span>Groups</span></AppLink>
        </li>
        <li className={ classNames({ active: this.isActive('/owners') }) }>
          <AppLink to="/owners" customRoot={ root }><i className="fas fa-address-book fa-fw"></i> <span>Owners</span></AppLink>
        </li>

        {/*
        <li className={ classNames('treeview', { active: this.isDropdownOpen('dailyRental') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(null, 'dailyRental') }>
            <i className="far fa-calendar-alt fa-fw"></i> <span>Daily rental</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/daily-rental/check-in-out-rulesets') }) }>
              <AppLink to="/daily-rental/check-in-out-rulesets" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Check in/out rulesets</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/daily-rental/cancellation-policies') }) }>
              <AppLink to="/daily-rental/cancellation-policies" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Cancellation policies</span></AppLink>
            </li>
          </ul>
        </li>
        */}

        <li className={ classNames('treeview', { active: this.isDropdownOpen('dataExchange') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(null, 'dataExchange') }>
            <i className="fas fa-exchange-alt fa-fw"></i> <span>Data Exchange</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/channels') }) }>
              <AppLink to="/channels" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Channels</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/synchronisations') }) }>
              <AppLink to="/synchronisations" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Synchronisations</span></AppLink>
            </li>
          </ul>
        </li>

        { (window && window.location.search === '?admin') ? [
          <li className={ classNames({ active: this.isActive('/zones') }) }>
            <AppLink to="/zones" customRoot={ root }><i className="fas fa-map-marker fa-fw"></i> <span>Zones</span></AppLink>
          </li>,
          <li className={ classNames({ active: this.isActive('/areas') }) }>
            <AppLink to="/areas" customRoot={ root }><i className="fas fa-map-marker-alt fa-fw"></i> <span>Areas</span></AppLink>
          </li>,
            <li className={ classNames({ active: this.isActive('/amenities') }) }>
              <AppLink to="/amenities" customRoot={ root }><i className="fas fa-list-ul fa-fw"></i> <span>Amenities</span></AppLink>
            </li>,
          ] : null
        }

      </ul>
    );
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  isDropdownOpen(name) {
    return this.state.dropdowns[name];
  }
  openDropdownFor(url) {
    let name;
    if (url.match(`^${this.resolveUrl('/channels')}`) || url.match(`^${this.resolveUrl('/synchronisations')}`)) name = 'dataExchange';
    if (url.match(`^${this.resolveUrl('/daily-rental')}`)) name = 'dailyRental';
    const dropdowns = Object.keys(this.state.dropdowns).reduce((object, _name) => ({ ...object, [_name]: false }), {});
    if (name) dropdowns[name] = true;
    this.setState({ dropdowns });
  }
  handleClickDropdown(name, evt = null) {
    if (evt) { evt.preventDefault(); }
    const dropdowns = { ...this.state.dropdowns };
    Object.keys(dropdowns)
      .filter(n => n !== name)
      .map(n => dropdowns[n] = false);
    dropdowns[name] = !dropdowns[name];
    this.setState({ dropdowns });
  }

  resolveUrl(url) {
    const currentUrl = path.join('/inventory', url);
    return PMS_URL === '/' ? currentUrl : `${PMS_URL}${currentUrl}`;
  }
}

InventoryMenu.propTypes = {
  location: React.PropTypes.object,
};

export default InventoryMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/InventoryMenu.jsx